import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories', {
        url: '/user-directories',
        redirectTo: 'company.user-directories.directory-groups',
        component: 'companyUserDirectories',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/user-directories.state.js